import { render } from "./AdmLectMng.vue?vue&type=template&id=ae7a224c&scoped=true"
import script from "./AdmLectMng.vue?vue&type=script&lang=js"
export * from "./AdmLectMng.vue?vue&type=script&lang=js"

import "./AdmLectMng.vue?vue&type=style&index=0&id=ae7a224c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae7a224c"]])

export default __exports__